import {Component} from 'react';
import "./About/about.css";
import "../../css/styles.css";

class InformationSources extends Component {
    
       render() {
            this.textClass = "font-weight-bold";
                
       return <>
            <div className="col-sm-8">
             <div className="card mt-3 rounded-corners-lg height-max">
                    <button className="pages-back-button ml-4 mt-4" 
                            onClick ={()=> this.props.goBack()}>
                                    Back
                    </button>
                <h3 className="mt-0 p-0 text-center">About Page</h3>
                    <h5 className="text-center">Information Sources</h5>
                    <div className="mt-2 mb-4 mr-4 ml-4 overflow-scroll">
                    <div className={this.textClass}>About the Authors</div>
                        <p className={this.textClass2}>This game was assembled by leveraging the talents of a team.
                           The primary author of the game has an MBA in Finance/Accounting as 
                           well as years working for a large discount-broker, and  
                           time spent in elementary school classroom education.   
                           Other members on the team include individuals who have financial certifications, 
                           and educational expertise.  All members of the team believe that financial literacy is
                           an essential skill in order for individuals to be successful.
                        </p>
                    <div className={this.textClass}>Job Information</div>
                        <p className={this.textClass2}>The list of jobs which are most common in the United States, job 
                           descriptions, likes and dislikes have been pulled
                           from a variety of sites including &nbsp;
                            <a href="https://www.indeed.jobs/" target="_blank" rel="noreferrer"
                                className="underline-this-text">indeed.com
                                </a>
                            &nbsp;
                            and <a href="https://www.glassdoor.com/" target="_blank" rel="noreferrer"
                                className="underline-this-text">glassdoor</a>. 
                        </p>
                    <div className={this.textClass}>Salary Information</div>
                        <p className={this.textClass2}>Salary ranges determined using &nbsp;&nbsp; 
                            <a href="https://www.salary.com/" target="_blank" rel="noreferrer"
                                className="underline-this-text">salary.com</a>. 
                        </p>
                    <div className={this.textClass}>Tax Calculation</div>
                        <p className={this.textClass2}>Estimated federal and FICA tax amounts derived using an online tax calculator
                          <br></br>( 
                        <a href="https://smartasset.com/taxes/colorado-tax-calculator" target="_blank" rel="noreferrer"
                            className="underline-this-text">
                            tax-calculator</a>).
                        </p>
                    <div className={this.textClass}>Other Financial Information</div>
                        <p className={this.textClass2}>There are many other cost items that are used 
                           within this game.
                           All items that have a financial impact (ex: miscellaneous
                           costs, health insurance, amount of college tuition, etc.) have been 
                           carefully established by doing research on the internet.   
                        </p>
                        <p>In general, costs and salaries reflect averages for the United States.
                           As a result, these amounts may not be consistent with specific 
                           geographic areas.   
                        </p>
                    </div>
                    <div className="mb-4"></div>
            </div>
            </div>         
            
        </>
    }

}

export default InformationSources;